/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/styles/global.css"

export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      const element = document.querySelector(location.hash)
      if (element) {
        element.scrollIntoView({ behavior: "smooth" })
      }
    }, 100) // Delay to ensure the DOM has updated
  }

  // if (
  //   !location.pathname?.startsWith("/ru/ru") &&
  //   location.pathname?.includes("/ru")
  // ) {
  //   window.location.replace(`/ru${location.pathname}`)
  // }
}
